<template>
  <div class="hotline">
    <img src="~@/assets/img/hotline.png">
    <div class="info">
      <p>业务热线：</p>
      <p>400-805-0105</p>
    </div>
    <div class="button"><a href="tel:400-805-0105">电话咨询</a></div>
    <div class="button1" @click="is_Wx = !is_Wx">客服微信</div>
    <div class="wx" v-show="is_Wx" @click="is_Wx = !is_Wx">
      <div class="info" @click.stop="">
        <img src="~@/assets/img/er.png">
        <p>客服微信，长按识别二维码</p>
        <div class="cha iconfont icon-chahao"  @click="is_Wx = !is_Wx"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hotline',
  data () {
    return {
      is_Wx: false
    }
  },
  mounted () {
  }
}
</script>
<style lang="stylus" scoped>
.hotline
  width 100%
  background rgba(0,0,0,.6)
  height px(110)
  position fixed
  bottom 0rem
  left 0px
  padding px(20) px(30)
  display flex
  align-items center
  z-index 1
  img
    width px(70)
    margin-left px(10)
    margin-right px(20)
  .info
    font-size px(26)
    color #fff
    flex 1
  .button,.button1
    width px(140)
    height px(52)
    border-radius px(10)
    background #D22016
    color #fff
    font-size px(24)
    text-align center
    display flex
    justify-content center
    line-height px(52)
  .button a
    display flex
    justify-content center
    width 100%
    height 100%
    text-align center
  .button1
    background #fff
    color #D22016
    margin-left px(30)
  .wx
    width 100%
    height 100%
    background rgba(0,0,0,.4)
    position fixed
    top 0px
    left 0px
    .info
      width px(484)
      height px(467)
      background #fff
      border-radius px(12)
      position absolute
      top 50%
      left 50%
      transform translate(-50%,-50%)
      padding-top px(50)
      img
        width px(312)
        margin 0 auto
        display block
      p
        color #666666
        font-size px(24)
        text-align center
        margin-top px(17)
      .cha
        color #fff
        width 100%
        font-size px(60)
        text-align center
        height px(60)
        line-height px(60)
        position absolute
        bottom px(-94)
</style>



// WEBPACK FOOTER //
// src/components/hotline.vue